import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { computed } from 'vue';
import {
  hasGapDeckung,
  hasNoDamage,
  hasOneChild,
  hasSeveralChildren,
  isAssistenzsystemAvailable,
  isErstbesitzer,
  isFahrerkreisAny,
  isFahrerkreisFix,
  isFahrerkreisNoAgeRestriction,
  isFahrerkreisVNDriver,
  isHaftpflicht,
  isNoAbweichenderHalter,
  isNoMinors,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoTeilkasko,
  isNotGermanOrIsCompany,
  isNotHaftpflichtFeature,
  isNoVollkasko,
  isNoVorversicherung,
  isOnlyHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
} from '@/features/Sparten/shared/inputDehydration/kfz/conditionalRequestDefinitions';
import { isFirma } from '@/features/Sparten/shared/inputDehydration/kfz/campKrad/inputDehydration';
import {
  hasHsnTsn,
  hasKradBauart,
  hasLeergewicht,
  hasZeitwert,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';

const isKradbauartAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasKradBauart.value),
  drop: ['fahrzeug.kradBauart'],
};

const isHsnTsnAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasHsnTsn.value),
  drop: ['fahrzeug.hsn', 'fahrzeug.tsn'],
};

const isZeitwertAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasZeitwert.value),
  drop: ['fahrzeug.zeitwert'],
};

const isLeergewichtAvailable: ConditionalRequestDefinition = {
  if: computed(() => !hasLeergewicht.value),
  drop: ['fahrzeug.leergewicht'],
};

/**
 * Firma-Droplist: wie die shared krad-Regel, plus das V2-Personenfeld. Der V2-Backend-Validator
 * erlaubt VN-Personenfelder nur fuer Nicht-Firmen (wie campv2/pkwv2).
 */
const isFirmaWithV2Fields: ConditionalRequestDefinition = {
  ...isFirma,
  drop: [
    ...isFirma.drop,
    'versicherungsnehmer.anSicherheitstrainingTeilnahmedatum',
  ],
};

export const inputDehydrationDefinitions: ConditionalRequestDefinition[] = [
  isAssistenzsystemAvailable,
  isNoAbweichenderHalter,
  isErstbesitzer,
  isFirmaWithV2Fields,
  isKradbauartAvailable,
  isHsnTsnAvailable,
  isZeitwertAvailable,
  isLeergewichtAvailable,
  isNotGermanOrIsCompany,
  isFahrerkreisVNDriver,
  isFahrerkreisFix,
  isFahrerkreisAny,
  isFahrerkreisNoAgeRestriction,
  isNoSaisonkennzeichen,
  isNotAnAdditionalCar,
  isNoVollkasko,
  isNoTeilkasko,
  isHaftpflicht,
  isNoMinors,
  isNoVorversicherung,
  hasOneChild,
  hasSeveralChildren,
  hasNoDamage,
  isOnlyHaftpflichtFeature,
  isNotHaftpflichtFeature,
  isOnlyVollkaskoFeature,
  hasGapDeckung,
  isVnVorsteuerabzugsberechtigt,
  temporaryField,
];
